/**
 * @generated SignedSource<<c9e0168f42e9cae97a01a9dd3e84b43f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubProfileModelDiscountCategoryChoices = "DISCOUNT_PUPIL_OTHER" | "DISCOUNT_PUPIL_PPKID" | "FULL_PRICE" | "%future added value";
export type EditProfileInput = {
  addressFirstLine?: string | null | undefined;
  addressSecondLine?: string | null | undefined;
  city?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  dbsExpirationDate?: string | null | undefined;
  dbsNumber?: string | null | undefined;
  discountCategory?: string | null | undefined;
  discountPercentage?: number | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  hasBook?: boolean | null | undefined;
  hasInstrument?: boolean | null | undefined;
  hasReturnedInstrument?: boolean | null | undefined;
  instrumentSuppliedByUs?: boolean | null | undefined;
  lastName?: string | null | undefined;
  paidBySchool?: boolean | null | undefined;
  phoneNumber?: string | null | undefined;
  postcode?: string | null | undefined;
  profileId: string;
  schoolClass?: string | null | undefined;
  schoolId?: string | null | undefined;
  schoolYear?: number | null | undefined;
  staffNoteForTeacher?: string | null | undefined;
};
export type EditProfileMutation$variables = {
  input: EditProfileInput;
};
export type EditProfileMutation$data = {
  readonly editProfile: {
    readonly errors: any | null | undefined;
    readonly profile: {
      readonly addressFirstLine: string | null | undefined;
      readonly addressSecondLine: string | null | undefined;
      readonly city: string | null | undefined;
      readonly dbsExpirationDate: string | null | undefined;
      readonly dbsNumber: string | null | undefined;
      readonly discountCategory: PianofunclubProfileModelDiscountCategoryChoices | null | undefined;
      readonly discountPercentage: number | null | undefined;
      readonly hasBook: boolean | null | undefined;
      readonly hasInstrument: boolean | null | undefined;
      readonly hasInvalidPhoneNumber: boolean;
      readonly hasReturnedInstrument: boolean | null | undefined;
      readonly id: string;
      readonly instrumentSuppliedByUs: boolean | null | undefined;
      readonly paidBySchool: boolean | null | undefined;
      readonly phoneNumber: string | null | undefined;
      readonly postcode: string | null | undefined;
      readonly school: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly schoolClass: string | null | undefined;
      readonly schoolYear: number | null | undefined;
      readonly staffNoteForTeacher: string | null | undefined;
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type EditProfileMutation = {
  response: EditProfileMutation$data;
  variables: EditProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditProfilePayload",
    "kind": "LinkedField",
    "name": "editProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "school",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasInvalidPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressFirstLine",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressSecondLine",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dbsNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dbsExpirationDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paidBySchool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountPercentage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasBook",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasInstrument",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instrumentSuppliedByUs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasReturnedInstrument",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffNoteForTeacher",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DjangoUserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditProfileMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditProfileMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0c774dc55f40f7f24023278aa2bcf27d",
    "id": null,
    "metadata": {},
    "name": "EditProfileMutation",
    "operationKind": "mutation",
    "text": "mutation EditProfileMutation(\n  $input: EditProfileInput!\n) {\n  editProfile(input: $input) {\n    success\n    errors\n    profile {\n      id\n      school {\n        id\n        name\n      }\n      phoneNumber\n      hasInvalidPhoneNumber\n      schoolYear\n      schoolClass\n      addressFirstLine\n      addressSecondLine\n      city\n      postcode\n      dbsNumber\n      dbsExpirationDate\n      paidBySchool\n      discountCategory\n      discountPercentage\n      hasBook\n      hasInstrument\n      instrumentSuppliedByUs\n      hasReturnedInstrument\n      staffNoteForTeacher\n      user {\n        id\n        firstName\n        lastName\n        email\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9b25d5d994ee0a59abc901b85fcc0e6";

export default node;
